import * as Sift from '@sift/types';
import { ENTITIES_PATH } from 'components/search/consts';

// Ensure that the id is always passed in since it's required to generate the href,
// but other fields are optional since in some cases, like recent searches, we will not
// have the full entity object.
interface EntityHrefData extends Partial<Sift.Entity> {
  id: string;
}

export default function getEntityHref(entity: Partial<EntityHrefData>): string {
  return entity.alternateEntityLink ? entity.alternateEntityLink : `${ENTITIES_PATH}/${entity.id}`;
}
